import styled from "styled-components";

export const StyledShowImg = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 16px;
    transform: translateX(-50%);
    .layout-ex-img {
        padding: 20px;
        background-color: #fff;
        border-radius: 20px;
        text-align: center;
        .title {
            font-size: 24px;
            color: #525257;
            font-weight: 600;
            margin-bottom: 5px;
        }
        .detail {
            font-size: 16px;
            color: #96979c;
            margin-bottom: 16px;
        }
    }
    .control-show-img {
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;
